import { nmlsLicenseApi, subCompanyLicenseStateApi } from 'app/services/api';
import axios from 'axios';
import { normalize, schema } from 'normalizr';

import { HTTP_RESPONSE_STATUS_CODES, SKIP_FORBIDDEN_RESPONSE_CONFIG } from 'constants/http';
import { NmlsLicensesLoadError } from 'constants/nmlsLicenses';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_LICENSED_STATES_ACTION_TYPE = createNamedActions(
  'subCompanyLicensedStates',
  {
    GET_STATES: 'GET_STATES',
    ADD_STATE: 'ADD_STATE',
    EDIT_STATE: 'EDIT_STATE',
    DELETE_STATE: 'DELETE_STATE',
    RESET_STATE: 'RESET_STATE',
    GET_NMLS_STATES: 'GET_NMLS_STATES',
    GET_NMLS_STATES_FAILURE: 'GET_NMLS_STATES_FAILURE',
    SYNC_NMLS_STATES: 'SYNC_NMLS_STATES',
  },
);

const licensedStates = new schema.Entity('data', {}, { idAttribute: license => license.id });

export const getSubCompanyLicensedStatesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyLicenseStateApi.getSubCompanyLicenseState(params);

  return dispatch({
    type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_STATES,
    payload: normalize(data, [licensedStates]).entities.data,
  });
});

export const createSubCompanyLicensedStateAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await subCompanyLicenseStateApi.createSubCompanyLicenseState(params);

    return dispatch({
      type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.ADD_STATE,
      payload: data,
    });
  },
);

export const editSubCompanyLicensedStateAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyLicenseStateApi.editSubCompanyLicenseState(params);

  return dispatch({
    type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.EDIT_STATE,
    payload: data,
  });
});

export const deleteSubCompanyLicensedStateAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await subCompanyLicenseStateApi.deleteSubCompanyLicenseState(params);

    return dispatch({
      type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.DELETE_STATE,
      payload: data,
      meta: params,
    });
  },
);

export const resetSubCompanyLicensedStatesAction = () => ({
  type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.RESET_STATE,
});

// The NMLS read is quiet: a 403 (a user without the NMLS-read claim) must not trip the global
// forbidden page-reload that re-bootstraps the app, and any failure is recorded so the view can say
// why it is empty instead of reading as "no licenses".
export const getSubCompanyNmlsLicensesAction = catchAsyncActionError(params => async dispatch => {
  try {
    const { data } = await nmlsLicenseApi.getSubCompanyNmlsLicenses({
      ...params,
      config: SKIP_FORBIDDEN_RESPONSE_CONFIG,
    });

    return dispatch({
      type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES,
      payload: data,
    });
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error;
    }

    return dispatch({
      type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES_FAILURE,
      payload:
        error?.response?.status === HTTP_RESPONSE_STATUS_CODES.FORBIDDEN
          ? NmlsLicensesLoadError.FORBIDDEN
          : NmlsLicensesLoadError.FAILED,
    });
  }
});

export const syncSubCompanyLicensedStatesFromNmlsAction = catchAsyncActionError(
  params => async dispatch => {
    await nmlsLicenseApi.syncSubCompanyLicensesFromNmls(params);

    dispatch({ type: SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.SYNC_NMLS_STATES });

    return dispatch(getSubCompanyLicensedStatesAction(params));
  },
);
